var exports = {
  "kL": "VideoPlayer.module__container___Q3dLYl",
  "Ki": "VideoPlayer.module__video___Q3dLYl",
  "ER": "VideoPlayer.module__videoHidden___Q3dLYl",
  "mz": "VideoPlayer.module__seekPreviewVideo___Q3dLYl",
  "IN": "VideoPlayer.module__posterOverlay___Q3dLYl",
  "lW": "VideoPlayer.module__posterImage___Q3dLYl",
  "aO": "VideoPlayer.module__thumbHashPlaceholder___Q3dLYl",
  "HT": "VideoPlayer.module__playOverlayButton___Q3dLYl",
  "$Z": "VideoPlayer.module__controlsOverlay___Q3dLYl",
  "hr": "VideoPlayer.module__progressBar___Q3dLYl",
  "xu": "VideoPlayer.module__controlsRow___Q3dLYl",
  "it": "VideoPlayer.module__controlsLeft___Q3dLYl",
  "QE": "VideoPlayer.module__controlsCenter___Q3dLYl",
  "BT": "VideoPlayer.module__controlsRight___Q3dLYl",
  "sL": "VideoPlayer.module__playPauseIndicator___Q3dLYl",
  "HA": "VideoPlayer.module__fillContainer___Q3dLYl",
  "Y5": "VideoPlayer.module__fullscreen___Q3dLYl",
};

module.exports = exports;
